import * as React from "react";
import { Navbar } from "flowbite-react";
import { StaticImage } from "gatsby-plugin-image";

export default function Header({ currentPath }) {
  return (
    <>
      <Navbar fluid rounded theme={customTheme.root}>
        <Navbar.Brand href="/" theme={customTheme.brand}>
          <StaticImage alt="The Two Circles Logo"
          className="mr-3 h-6 sm:h-9 w-6 sm:w-9"
          src="../images/logo.png" ></StaticImage>
          <span className="self-center whitespace-nowrap text-2xl font-semibold dark:text-white">
            The Two Circles
          </span>
        </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse theme={customTheme.collapse}>
          <Navbar.Link active={currentPath === "/"} href="/" theme={customTheme.link}>
            Home
          </Navbar.Link>
          <Navbar.Link active={currentPath === "/about"} href="/about" theme={customTheme.link}>
            About
          </Navbar.Link>
          <Navbar.Link
            active={currentPath === "/presentation"}
            href="/presentation"
            theme={customTheme.link}
          >
            Presentation
          </Navbar.Link>
          <Navbar.Link active={currentPath === "/download"} href="/download" theme={customTheme.link}>
            Download
          </Navbar.Link>
          <Navbar.Link active={currentPath === "/contact"} href="/contact" theme={customTheme.link}>
            Contact
          </Navbar.Link>
        </Navbar.Collapse>
      </Navbar>
    </>
  );
}

const customTheme = {
  root: {
    base: "bg-white px-2 py-2.5 dark:border-gray-700 dark:bg-gray-800 sm:px-4",
    rounded: {
      on: "rounded",
      off: "",
    },
    bordered: {
      on: "border",
      off: "",
    },
    inner: {
      base: "mx-auto flex flex-wrap items-center justify-between",
      fluid: {
        on: "",
        off: "container",
      },
    },
  },
  brand: {
    base: "flex items-center",
  },
  collapse: {
    base: "w-full md:block md:w-auto",
    list: "font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700",
    hidden: {
      on: "hidden",
      off: "",
    },
  },
  link: {
    base: "block py-2 pr-4 pl-3 md:p-0",
    active: {
      on: "block py-2 pl-3 pr-4 text-white bg-blue-700 rounded md:bg-transparent md:text-blue-700 md:p-0 dark:text-white md:dark:text-blue-500",
      off: "block py-2 pl-3 pr-4 text-gray-900 rounded hover:bg-gray-100 md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 dark:text-white md:dark:hover:text-blue-500 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent",
    },
    disabled: {
      on: "text-gray-400 hover:cursor-not-allowed dark:text-gray-600",
      off: "",
    },
  },
  toggle: {
    base: "inline-flex items-center rounded-lg p-2 text-sm text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600 md:hidden",
    icon: "h-6 w-6 shrink-0",
  },
};
